import { Tag } from "@phosphor-icons/react";
import { Checkbox } from "../ui/checkbox";
import { getTextSecondary } from "../../lib/styleHelpers";

const ALL_CATEGORIES = [
  "Cross-border Trade",
  "Currency Arbitrage",
  "Real Estate",
  "Commodities",
  "E-commerce",
  "Technology",
  "Agriculture",
  "Energy",
];

export { ALL_CATEGORIES };

export function CategoryPreferences({ preferredCategories, setPreferredCategories, isDark }) {
  const toggleCategory = (category) => {
    setPreferredCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  return (
    <>
      <h2 className={`text-lg font-bold mb-6 ${isDark ? "text-white" : "text-gray-900"}`}>
        <Tag size={20} className="inline text-purple-500 mr-2" />
        Category Preferences
      </h2>
      <p className={`${getTextSecondary(isDark)} text-sm font-body mb-4`}>
        Select categories you're interested in for opportunity generation
      </p>
      <div className="grid grid-cols-2 gap-3">
        {ALL_CATEGORIES.map((cat) => (
          <label
            key={cat}
            className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
              preferredCategories.includes(cat)
                ? isDark
                  ? "border-purple-500/40 bg-purple-500/5"
                  : "border-purple-300 bg-purple-50"
                : isDark
                  ? "border-white/10 hover:border-white/20"
                  : "border-gray-200 hover:border-gray-300"
            }`}
            data-testid={`category-${cat.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <Checkbox
              checked={preferredCategories.includes(cat)}
              onCheckedChange={() => toggleCategory(cat)}
            />
            <span className={`text-sm ${isDark ? "text-gray-300" : "text-gray-700"}`}>{cat}</span>
          </label>
        ))}
      </div>
    </>
  );
}
